export default __webpack_public_path__ + "static/media/022-sport car.af2a4254.svg";